import React, { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import { $l } from '../../../locales';

import Tabs from '../Tabs';

interface HistoryTab {
  text: string;
  value: string;
  isActive: boolean;
}

interface IButton {
  text: string;
  value: string;
  isActive?: boolean;
  isDisabled?: boolean;
}

interface IProps {
  type: 'chats' | 'tickets';
  onTabClick: (tab: string) => void;
}

const SupportHistoryTabs: FC<IProps> = ({ type, onTabClick }) => {
  const [, setSearchParams] = useSearchParams();

  const onClick = ({ value }: IButton) => {
    setSearchParams(value === 'chats' ? { t: value } : {});
    onTabClick(value);
  };

  const supportHistoryTabs: HistoryTab[] = [
    {
      text: $l('SUPPORT_HISTORY.TICKET_HISTORY'),
      value: 'tickets',
      isActive: type === 'tickets',
    },
    {
      text: $l('SUPPORT_HISTORY.CHAT_HISTORY'),
      value: 'chats',
      isActive: type === 'chats',
    },
  ];

  return <Tabs onTabClick={onClick} buttons={supportHistoryTabs} />;
};

export default SupportHistoryTabs;
